import React from 'react';
import { Attributes } from '@leverege/ui-attributes';
import Model from "./ResourceImageCustomTextModel.js";
import ResourceImageValueComponent from "./ResourceImageValueComponent.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ResourceImageCustomTextValueRenderer(props) {
  const {
    value,
    model,
    context
  } = props;
  const attribute = Attributes.getAttribute(model.attrName, model.objectType);
  let path = attribute?.source?.attribute?.path;
  if (path) {
    path = `resourceImage/${path}`;
  } else {
    return null;
  }
  const style = {
    height: Model.getHeight(model),
    width: Model.getWidth(model),
    verticalAlign: Model.getVerticalAlign(model)
  };
  return /*#__PURE__*/_jsx(ResourceImageValueComponent, {
    value: value,
    path: path,
    clientProps: context.clientProps,
    valueStyle: style
  });
}
export default {
  id: 'molten.CustomTextValueRenderer.resourceImage',
  valueType: 'resourceImage',
  Component: ResourceImageCustomTextValueRenderer
};